import React, { Fragment, memo, useCallback, useEffect, useRef, useState } from 'react'
import { Group, Rect } from 'react-konva'
import { PATTERN_TYPE } from '../../../../constant'
import { toaster } from '../../../../shared/PFToast'
import SpinnerLayer from '../layers/SpinnerLayer'
import { getRotatedBoundingBox2 } from '../../context/SelectedVariantContext/helper'

const ImageLayer = memo((props) => {
    const { imageProps, background } = props

    const { patternType } = imageProps

    const imageRef = useRef(null)

    const [image, setImage] = useState(null)
    const [loading, setLoading] = useState(true)
    const [grid, setGrid] = useState([])

    useEffect(() => {
        setLoading(true)

        const img = new window.Image()
        img.crossOrigin = 'Anonymous'

        img.onload = () => {
            const timer = setTimeout(() => {
                setImage(img)
                setLoading(false)
            }, 100)
            return () => {
                clearTimeout(timer)
            }
        }
        img.onerror = (e) => {
            setLoading(false)
            toaster({ type: 'error', message: 'Error loading image' + e, duration: 6000 })
        }

        img.src = imageProps.src
    }, [imageProps.src])

    // const getAdjustedSize = useCallback(
    //     (scaleFactor = 1) => {
    //         const { width: imageWidth, height: imageHeight, scaleX, scaleY } = imageProps
    //         if (scaleX && scaleY) {
    //             const tempScaleX = scaleX < 0 ? -scaleX : scaleX
    //             const tempScaleY = scaleY < 0 ? -scaleY : scaleY

    //             scaleFactor = Math.min(tempScaleX, tempScaleY) || 1
    //         }

    //         const adjustedWidth = imageWidth * scaleFactor
    //         const adjustedHeight = imageHeight * scaleFactor
    //         const adjustedRows = Math.ceil(background.width / adjustedWidth)
    //         let adjustedCols = Math.ceil(background.height / adjustedHeight)
    //         if (adjustedCols % 2 === 0) {
    //             adjustedCols = adjustedCols + 1
    //         }
    //         return { adjustedRows, adjustedCols, adjustedWidth, adjustedHeight }
    //     },
    //     [imageProps, background],
    // )

    const getAdjustedSize = useCallback(
        (scaleFactor = 1) => {
            const { width: imageWidth, height: imageHeight, scaleX, scaleY } = imageProps
            if (scaleX && scaleY) {
                const tempScaleX = scaleX < 0 ? -scaleX : scaleX
                const tempScaleY = scaleY < 0 ? -scaleY : scaleY

                scaleFactor = Math.min(tempScaleX, tempScaleY) || 1
            }

            const adjustedWidth = imageWidth * scaleFactor
            const adjustedHeight = imageHeight * scaleFactor
            const adjustedRows = Math.ceil(background.width / adjustedWidth)
            let adjustedCols = Math.ceil(background.height / adjustedHeight)
            if (adjustedCols % 2 === 0) {
                adjustedCols = adjustedCols + 1
            }
            return { adjustedRows: adjustedRows * 2, adjustedCols: adjustedCols * 2, adjustedWidth, adjustedHeight }
        },
        [imageProps, background],
    )

    const renderGrid = useCallback(
        (rows = 2, cols = 2) => {
            let matrix = []
            let scaleFactor = 1
            const {
                x: imageX,
                y: imageY,
                hasPattern,
                patternType,
                horizontalSpacing = 0,
                verticalSpacing = 0,
            } = imageProps

            if (hasPattern) {
                const { adjustedRows, adjustedCols, adjustedWidth, adjustedHeight } = getAdjustedSize(scaleFactor)
                if (patternType === PATTERN_TYPE.HORIZONTAL) {
                    for (let i = -adjustedRows; i <= adjustedRows; i++) {
                        let x = imageX - i * (adjustedWidth + Number(horizontalSpacing) / background.ratioDefault)
                        if (x === 0) continue
                        matrix.push({
                            ...imageProps,
                            y: imageY,
                            x,
                        })
                    }
                } else if (patternType === PATTERN_TYPE.VERTICAL) {
                    for (let i = -adjustedCols; i <= adjustedCols; i++) {
                        let y = imageY - i * (adjustedHeight + Number(verticalSpacing) / background.ratioDefault)
                        if (y === 0) continue
                        matrix.push({
                            ...imageProps,
                            fillPatternImage: image,
                            x: imageX,
                            y: y,
                        })
                    }
                } else {
                    for (let i = -adjustedRows; i <= adjustedRows; i++) {
                        for (let j = -adjustedCols; j < adjustedCols; j++) {
                            if (i === 0 && j === 0) continue
                            let x = imageX - i * (adjustedWidth + Number(horizontalSpacing) / background.ratioDefault)
                            let y = imageY - j * (adjustedHeight + Number(verticalSpacing) / background.ratioDefault)
                            if (patternType === PATTERN_TYPE.HORIZONTAL_BRICK) {
                                x += j % 2 === 0 ? 0 : adjustedWidth / 2
                            }
                            if (patternType === PATTERN_TYPE.VERTICAL_BRICK) {
                                y += i % 2 === 0 ? 0 : adjustedHeight / 2
                            }

                            matrix.push({
                                ...imageProps,
                                fillPatternImage: image,
                                x: x,
                                y: y,
                                name: `rect_${i}_${j}`,
                                key: `rect_${i}_${j}`,
                                mainElement: i === 0 && j === 0,
                            })
                        }
                    }
                }
            } else {
                matrix = []
            }
            return matrix
        },

        // eslint-disable-next-line react-hooks/exhaustive-deps
        [imageProps, background],
    )

    useEffect(() => {
        setGrid(renderGrid())
    }, [renderGrid])

    return (
        <Group
            onClick={() => {
            }}
            draggable={false}
        // ref={groupRef}
        >
            {grid.map((item, index) => (
                <Rect
                    {...item}
                    // visible={false}
                    draggable={false}
                    fillPatternImage={image}
                    globalCompositeOperation="source-over"

                />
            ))}
            <Rect
                {...imageProps}
                draggable={false}
                fillPatternImage={image}
                globalCompositeOperation="source-over"
            />
        </Group>
        // <Rect
        //     width={imageProps.width}
        //     height={imageProps.height}
        //     // scale={0.2}
        //     x={imageProps.x}
        //     y={imageProps.y}
        //     fillPatternImage={image}
        // />
    )
})

export default ImageLayer

